export default class DetailsColumn {
  constructor({ columnName, columnWidth, fields }) {
    this.columnName = columnName;
    this.columnWidth = columnWidth;
    this.fields = fields;
  }
}
